import React from "react";
// import { TbDragDrop2 } from "react-icons/tb";
import { Element } from "@craftjs/core";
import Container from "components/general/Container";
import { Box } from "components/ui";
import { Platform } from "react-native";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { PageContainer } from "./PageContainer";

export const PageFeaturesTitleContainer = ({ ...props }) => {
	return <>{props.children}</>;
};

export const PageFeaturesPanelContainer = ({ children }: any) => {
	if (!children || !children.props) return null;

	const cloneChildren = children.props.children;
	const isMobile = useIsMobile();
	return (
		<Box flexDirection={isMobile ? "column" : "row"} alignItems={Platform.OS === "web" ? "center" : "stretch"} paddingVertical={24} gap={24} width={"$full"} justifyContent="space-between">
			{cloneChildren.map((child: any, key: number) => {
				return (
					<Box height={"$full"} flex={1} key={key}>
						{child}
					</Box>
				);
			})}
		</Box>
	);
};

export const PageFeaturesDescriptionContainer = ({ ...props }) => {
	return <Box>{props.children}</Box>;
};
export const PageFeaturesButtonContainer = ({ ...props }) => {
	return <>{props.children}</>;
};

export const PageFeatures = ({ ...props }: any) => {
	const isMobile = useIsMobile();
	if (isMobile) {
		return (
			<Box bg={props.background}>
				<Container sx={{ paddingVertical: 48 }}>
					<PageContainer background="#1A428A" borderRadius={12} style={{ background: "#1A428A", borderRadius: 12 }}>
						<Box pt={48} alignItems="center">
							<Element is={PageFeaturesTitleContainer} canvas id="feature-title-container" data-cy="feature-title"></Element>
						</Box>
						<Box paddingHorizontal={32} width={"$full"} maxWidth={1056} flexDirection="row" justifyContent="space-around" gap={24}>
							<Element canvas id="features-drop-location" is={PageFeaturesPanelContainer} data-cy="features-drop-location"></Element>
						</Box>
						<Box paddingHorizontal={32}>
							<Element data-cy="features-description" id="features-description" is={PageFeaturesDescriptionContainer}></Element>
						</Box>
						<Box flexDirection="row" justifyContent="center" gap={8} pt={30} pb={32} alignItems="center">
							<Element canvas data-cy="features-button" id="features-button" is={PageFeaturesButtonContainer}></Element>
						</Box>
					</PageContainer>
				</Container>
			</Box>
		);
	}
	return (
		<Box bg={props.background}>
			<Container>
				<PageContainer background="#1A428A" borderRadius={12} style={{ borderRadius: 12 }}>
					<Box gap={40} paddingHorizontal={64} alignItems="center" paddingVertical={96} {...props}>
						<Box alignItems="center">
							<Element is={PageFeaturesTitleContainer} canvas id="feature-title-container" data-cy="feature-title"></Element>
						</Box>
						<Box width={"$full"} maxWidth={1056} flexDirection="row" justifyContent="space-around" gap={24}>
							{/* PANEL HERE */}
							{/* <PageText color="white" fontSize={16} text="PANEL LIST" /> */}
							<Element canvas id="features-drop-location" is={PageFeaturesPanelContainer} data-cy="features-drop-location"></Element>
						</Box>
						<Box alignItems="center">
							{/* @ts-ignore */}
							<Box maxWidth={780} style={{ textAlign: "justify" }}>
								<Element data-cy="features-description" id="features-description" is={PageFeaturesDescriptionContainer}></Element>
							</Box>
						</Box>
						<Box flexDirection="row" gap={12} justifyContent="center">
							<Element canvas data-cy="features-button" id="features-button" is={PageFeaturesButtonContainer}></Element>
						</Box>
					</Box>
				</PageContainer>
			</Container>
		</Box>
	);
};
